import React, { useContext, useEffect, useState } from 'react';
import ContextStates from '../context/ContextStates';
import { Link } from 'react-router-dom';


const SideCompra = () => {
    const [total, setTotal] = useState(0)
    const { venta, setFormView, setViewOpen, precio } = useContext(ContextStates);

    useEffect(() => {
        const calcTotal = () => {
            let aux = 0;
            if (typeof venta !== 'undefined') {
                venta.forEach(element => {
                    if (!precio) {
                        if (element.tipopromo === '1' || element.tipopromo === '2') {
                            aux = aux + parseFloat(element.preciopromocion * element.cantidad);
                        }
                        else {
                            if (element.tipopromo === '3') {
                                let precio = 0;
                                if (element.cantidad >= element.cantidadminima) {
                                    let cantPromos = parseFloat(element.cantidad) / parseFloat(element.cantidadminima);
                                    let cantPagos = element.cantidad - (parseFloat(element.cantidaddescuento) * cantPromos);
                                    precio = cantPagos * parseFloat(element.precio);
                                } else {
                                    precio = parseFloat(element.cantidad) * parseFloat(element.precio);
                                }
                                aux = aux + precio;
                            } else {
                                aux = aux + parseFloat(element.precio) * element.cantidad;
                            }
                        }
                    }
                    else {
                        aux = aux + parseFloat(element.preciopormayor * element.cantidad);
                    }
                });
                setTotal(aux)
            }
        }
        calcTotal()
    }, [venta, precio])

    const finalizarCompra = () => {
        if (total > 0) {
            setFormView(200);
            setViewOpen(true);
        }
    }

    return (
        <div className="w-full p-5">
            <div className='w-full mt-10'>
                <p className='text-center text-4xl font-light'>Total: ${total.toLocaleString("es-AR", { maximumFractionDigits: 2 })}</p>
            </div>
            <div className='w-full mt-10'>
                <Link to={"/"}>
                    <button type='button'
                        className={`w-full p-3 text-white uppercase font-semibold rounded bg-blue-600`}
                    >
                        Continuar explorando
                    </button>
                </Link>
            </div>
            <div className='w-full mt-10'>
                <Link
                    to={"/pedido"}
                >
                    <p
                        className={`w-full p-3 text-center text-white uppercase font-semibold rounded ${total > 0 ? 'bg-orange-500' : 'bg-orange-200'}`}                
                    >
                        Finalizar compra

                    </p>
                </Link>
            </div>

        </div>
    )
}

export default SideCompra